import { MemreButton, MemreFlexBox, MemreModal } from 'components/core';
import React, { useState } from 'react';
import ImageUploadModal from '../ImageUpload/ImageUploadModal';

export default function ImageBlock({ item }) {
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const handleButtonClick = () => {
    setModalContent(<ImageUploadModal addImageMethod={item.addImage} close={() => setModalContent(null)} />);
  };

  return (
    <MemreFlexBox direction="row" gap={1} justify="center" align="center" sx={{ p: 4, flex: 1 }}>
      {!item.url && <MemreButton variant="outlined" text="Add Image" onClick={handleButtonClick} />}
      {item.url && <img src={item.url} alt="Image" style={{ width: '100%' }} />}
      <MemreModal padding={0}>{modalContent}</MemreModal>
    </MemreFlexBox>
  );
}
